module.exports = __webpack_public_path__ + "img/Frame 1.48dcadf8.svg";